import { TableSelectionDialogComponent } from './table-selection-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonLayoutModule, CommonUIModule, CommonTranslationModule } from '@sdbn/common';

import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { TMCTableModule } from '@sdbn/common';



@NgModule({
  declarations: [TableSelectionDialogComponent],
  exports: [TableSelectionDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    TMCTableModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule
  ]
})
export class TableSelectionDialogModule { }
